import axios from "axios";
import Vue from "vue";
export const state = {
  sets: [],
  otherSets: [],
  monthlyTests: [],
  considered: [],
  marked: [],
  criteria: [],
  save_status: false,
};
export const getters = {
  AllSets: (state) => state.sets.data,
  TestConsideration: (state) => state.considered.data,
  TestMarked: (state) => state.marked.data,
  OtherSets: (state) => state.otherSets.data,
  MonthlyTests: (state) => state.monthlyTests.data,
  SaveStatus: (state) => state.save_status,
  AllCriteria: (state) => state.criteria.data,
};

export const mutations = {
  SET_SETS(state, newValue) {
    state.sets = newValue;
  },
  SET_CONSIDERED(state, newValue) {
    state.considered = newValue;
  },
  SET_OTHERSETS(state, newValue) {
    state.otherSets = newValue;
  },
  SET_MONTHLYTESTS(state, newValue) {
    state.monthlyTests = newValue;
  },
  SET_MARKED(state, newValue) {
    state.marked = newValue;
  },
  SET_CRITERIA(state, newValue) {
    state.criteria = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  addSet({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("tests", payload)
      .then(() => {
        dispatch("fetchSets");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  reportPdf({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("report/pdf")
      .then((response) => {
        console.log(response.config.baseURL + response.config.url);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "href",
          response.config.baseURL + response.config.url
        );
        link.setAttribute("target", "_blank");
        // link.setAttribute('download', 'remaining_fee.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  },
  // Edit  Set
  editSet({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`tests/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchSets");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Delete Set
  deleteSet({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`tests/${payload.id}`)
      .then(() => {
        dispatch("fetchSets");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },

  addSetting({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("test_marked", payload)
      .then(() => {
        dispatch("fetchSetContributions");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Edit  Set
  editSetting({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`test_marked/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchSetContributions");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Delete Set
  deleteSetting({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`test_marked/${payload.id}`)
      .then(() => {
        dispatch("fetchSetContributions");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },

  addSetConsideration({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("tests_considered", payload)
      .then(() => {
        dispatch("fetchSetConsiderations");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  deleteSetConsideration({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`tests_considered/${payload.id}`)
      .then(() => {
        dispatch("fetchSetConsiderations");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },

  addMonthlyTests({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("add_monthly_test", payload)
      .then(() => {
        dispatch("fetchMonthlyTests");
        dispatch("fetchOtherSets");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  deleteMonthlyTest({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`tests_considered/${payload.id}`)
      .then(() => {
        dispatch("fetchMonthlyTests");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },

  addCriteria({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("criteria", payload)
      .then(() => {
        dispatch("fetchCriteria");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Criteria Was Saved Successfully",
        };
        commit("pushNotification", message);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Adding Criteria",
        };
        commit("pushNotification", message);
      });
  },
  eddCriteria({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`criteria/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchCriteria");
        commit("SET_SAVE_STATUS", false);
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Criteria Was Saved Successfully",
        };
        commit("pushNotification", message);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Adding Criteria",
        };
        commit("pushNotification", message);
      });
  },
  deleteCriteria({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`criteria/${payload.id}`)
      .then(() => {
        dispatch("fetchCriteria");
        commit("SET_SAVE_STATUS", false);
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Criteria Was Removed Successfully",
        };
        commit("pushNotification", message);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Adding Criteria",
        };
        commit("pushNotification", message);
      });
  },

  fetchSets({ commit }) {
    axios.get("tests").then((pos) => {
      commit("SET_SETS", pos.data);
    });
  },
  fetchSetConsiderations({ commit }) {
    axios.get("tests_considered").then((sta) => {
      commit("SET_CONSIDERED", sta.data);
    });
  },
  fetchSetContributions({ commit }) {
    axios.get("test_marked").then((sta) => {
      commit("SET_MARKED", sta.data);
    });
  },
  fetchMonthlyTests({ commit }) {
    axios.get("monthly_test").then((sta) => {
      commit("SET_MONTHLYTESTS", sta.data);
    });
  },
  fetchOtherSets({ commit }) {
    axios.get("other_sets").then((sta) => {
      commit("SET_OTHERSETS", sta.data);
    });
  },
  fetchCriteria({ commit }) {
    axios.get("criteria").then((sta) => {
      commit("SET_CRITERIA", sta.data);
    });
  },
};
